import { lazy } from 'react';
import {LocalLoadable} from "@g2-shared/components";

export const NotFound = LocalLoadable(lazy(() => import('../theme/pages/Page404')));
export const PageOne = LocalLoadable(lazy(() => import('../theme/pages/PageOne')));
